(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gta"] && !Shopify.designMode) return;
  try {
    
  function initGtaApp(root) {
    if (!root || root.dataset.gtaInitialized === 'true') return;
    root.dataset.gtaInitialized = 'true';

    var productBar = root.querySelector('.gta-app__bar');
    var iframe = root.querySelector('[data-gta-iframe]');
    var variantsNode = root.querySelector('[data-gta-variants]');
    var addButton = root.querySelector('[data-gta-add]');
    var resetButton = root.querySelector('[data-gta-reset]');
    var priceNode = root.querySelector('[data-gta-price]');
    var comparePriceNode = root.querySelector('[data-gta-compare-price]');
    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-gta-option]'));
    var variants = JSON.parse(variantsNode.textContent || '[]');
    var initialOptions = optionSelects.map(function(select) { return select.value; });
    var iframeOrigin = new URL(iframe.src).origin;
    var supabaseBase = 'https://bmqexmsqwxfzejjkkevb.supabase.co/storage/v1/object/public/posters';
    var posthogApiHost = 'https://eu.i.posthog.com';
    var posthogUiHost = 'https://eu.posthog.com';
    var posthogScriptUrl = 'https://eu-assets.i.posthog.com/static/1.410.5/array.js';
    var posthogEnabled = root.dataset.gtaPosthogEnabled === 'true';
    var posthogToken = String(root.dataset.gtaPosthogToken || '').trim();
    var analyticsPermission = false;
    var analyticsActive = false;
    var posthogInitialized = false;
    var parentReadyCaptured = false;
    var posthogLoadPromise = null;
    var pendingAdd = null;
    var commerceError = '';
    var commerceSyncTimer = null;
    var commerceSyncAttempts = 0;
    var viewportFrame = null;
    function syncProductBarVisibility() {
      if (!productBar) return;

      productBar.hidden = true;
      productBar.setAttribute('aria-hidden', 'true');
      productBar.style.setProperty('display', 'none', 'important');
    }

    function postToIframe(message) {
      if (!iframe || !iframe.contentWindow) return;
      iframe.contentWindow.postMessage(message, iframeOrigin);
    }

    function hasValidPostHogToken() {
      return posthogToken.length >= 20
        && posthogToken.length <= 200
        && /^[A-Za-z0-9_-]+$/.test(posthogToken);
    }

    function sendAnalyticsState() {
      var allowed = Boolean(posthogEnabled && analyticsActive && hasValidPostHogToken());

      postToIframe({
        type: 'GTA_ANALYTICS_CONSENT',
        allowed: allowed,
        token: allowed ? posthogToken : '',
        apiHost: posthogApiHost
      });
    }

    function loadPostHog() {
      if (window.posthog && typeof window.posthog.init === 'function') {
        return Promise.resolve(window.posthog);
      }

      if (posthogLoadPromise) return posthogLoadPromise;

      posthogLoadPromise = new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.src = posthogScriptUrl;
        script.onload = function() {
          if (window.posthog && typeof window.posthog.init === 'function') {
            resolve(window.posthog);
            return;
          }

          reject(new Error('PostHog loaded without a browser client.'));
        };
        script.onerror = function() {
          reject(new Error('PostHog browser client could not be loaded.'));
        };
        document.head.appendChild(script);
      });

      return posthogLoadPromise;
    }

    function initializePostHog() {
      return loadPostHog().then(function(posthog) {
        if (posthog.__loaded && posthog.config && posthog.config.token !== posthogToken) {
          throw new Error('A different PostHog project is already active on this page.');
        }

        if (!posthogInitialized && !posthog.__loaded) {
          posthog.init(posthogToken, {
            api_host: posthogApiHost,
            ui_host: posthogUiHost,
            defaults: '2026-05-30',
            person_profiles: 'identified_only',
            autocapture: false,
            capture_pageview: true,
            capture_pageleave: true,
            strict_script_versioning: true,
            session_recording: {
              recordCrossOriginIframes: true,
              maskAllInputs: true,
              maskTextSelector: '[data-private-text]',
              captureCanvas: {
                canvasFps: 2,
                canvasQuality: '0.25'
              }
            }
          });
        }

        posthogInitialized = true;
        posthog.opt_in_capturing();
        posthog.startSessionRecording();
        return posthog;
      });
    }

    function disablePostHog() {
      analyticsActive = false;
      parentReadyCaptured = false;

      if (window.posthog && window.posthog.__loaded) {
        window.posthog.stopSessionRecording();
        window.posthog.opt_out_capturing();
      }

      sendAnalyticsState();
    }

    function applyAnalyticsPermission(allowed) {
      analyticsPermission = allowed === true;

      if (!posthogEnabled || !hasValidPostHogToken() || !analyticsPermission) {
        disablePostHog();
        return;
      }

      analyticsActive = false;
      sendAnalyticsState();

      initializePostHog()
        .then(function(posthog) {
          if (!analyticsPermission) {
            disablePostHog();
            return;
          }

          analyticsActive = true;
          if (!parentReadyCaptured) {
            parentReadyCaptured = true;
            posthog.capture('gta_customizer_parent_ready', {
              component: 'gta_product_customizer'
            });
          }
          sendAnalyticsState();
        })
        .catch(function(error) {
          console.warn('PostHog session replay could not start:', error);
          disablePostHog();
        });
    }

    function readAnalyticsPermission() {
      try {
        return Boolean(
          window.Shopify
          && window.Shopify.customerPrivacy
          && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
          && window.Shopify.customerPrivacy.analyticsProcessingAllowed()
        );
      } catch (error) {
        return false;
      }
    }

    function initializeConsentTracking() {
      document.addEventListener('visitorConsentCollected', function(event) {
        var detail = event && event.detail ? event.detail : {};
        var allowed = typeof detail.analyticsAllowed === 'boolean'
          ? detail.analyticsAllowed
          : readAnalyticsPermission();

        applyAnalyticsPermission(allowed);
      });

      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        applyAnalyticsPermission(false);
        return;
      }

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function(error) {
          applyAnalyticsPermission(error ? false : readAnalyticsPermission());
        }
      );
    }

    var allowedAnalyticsProperties = {
      gta_customizer_opened: ['surface'],
      gta_customizer_step_viewed: ['step'],
      gta_customizer_orientation_changed: ['orientation'],
      gta_customizer_pin_count_changed: ['change', 'pin_count'],
      gta_customizer_product_option_changed: ['option_name', 'option_value'],
      gta_customizer_add_to_cart_started: [],
      gta_customizer_add_to_cart_succeeded: [],
      gta_customizer_add_to_cart_failed: [],
      gta_customizer_reset: []
    };

    function captureCustomizerAnalytics(message) {
      if (!analyticsActive || !window.posthog || !window.posthog.__loaded) return;

      var eventName = String(message.eventName || '');
      var allowedProperties = allowedAnalyticsProperties[eventName];
      if (!allowedProperties) return;

      var sourceProperties = message.properties && typeof message.properties === 'object'
        ? message.properties
        : {};
      var safeProperties = { component: 'gta_product_customizer' };

      allowedProperties.forEach(function(key) {
        var value = sourceProperties[key];

        if (typeof value === 'string') {
          safeProperties[key] = value.slice(0, 80);
        } else if (typeof value === 'number' && Number.isFinite(value)) {
          safeProperties[key] = value;
        } else if (typeof value === 'boolean') {
          safeProperties[key] = value;
        }
      });

      window.posthog.capture(eventName, safeProperties);
    }

    function sendViewportState() {
      if (!iframe || !iframe.contentWindow) return;
      if (viewportFrame !== null) cancelAnimationFrame(viewportFrame);

      viewportFrame = requestAnimationFrame(function() {
        viewportFrame = null;

        var viewportHeight = window.visualViewport
          ? window.visualViewport.height
          : window.innerHeight;
        var iframeTop = Math.max(iframe.getBoundingClientRect().top, 0);
        var availableHeight = Math.floor(viewportHeight - iframeTop - 12);

        if (availableHeight < 320) return;
        postToIframe({
          type: 'GTA_PARENT_VIEWPORT',
          height: availableHeight
        });
      });
    }

    function selectedOptions() {
      return optionSelects.map(function(select) { return select.value; });
    }

    function selectedOptionDetails() {
      return optionSelects.map(function(select) {
        var field = select.closest('.gta-app__field');
        var label = field ? field.querySelector('.gta-app__label') : null;

        return {
          name: label ? label.textContent.trim() : '',
          value: select.value
        };
      });
    }

    function selectedOptionValue(optionName) {
      var targetName = optionName.toLowerCase();
      var details = selectedOptionDetails();
      var match = details.find(function(option) {
        return option.name.toLowerCase() === targetName;
      });

      return match ? match.value : '';
    }

    function productOptionCatalog() {
      return optionSelects.map(function(select) {
        var field = select.closest('.gta-app__field');
        var label = field ? field.querySelector('.gta-app__label') : null;

        return {
          name: label ? label.textContent.trim() : '',
          values: Array.prototype.map.call(select.options, function(option) {
            return option.value;
          })
        };
      });
    }

    function selectedOptionsByName() {
      return selectedOptionDetails().reduce(function(selected, option) {
        selected[option.name] = option.value;
        return selected;
      }, {});
    }

    function findSelectedVariant() {
      var options = selectedOptions();
      return variants.find(function(variant) {
        return variant.options.length === options.length && variant.options.every(function(value, index) {
          return value === options[index];
        });
      }) || variants[0];
    }

    function findVariantByNamedOptions(namedOptions) {
      var catalog = productOptionCatalog();

      return variants.find(function(variant) {
        return catalog.every(function(option, index) {
          return String(variant.options[index]) === String(namedOptions[option.name]);
        });
      }) || null;
    }

    function sendCommerceState() {
      var catalog = productOptionCatalog();
      var selected = selectedOptionsByName();
      var variant = findVariantByNamedOptions(selected);
      var compareAtPrice = '';

      if (variant && variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        compareAtPrice = variant.compareAtPriceFormatted;
      }

      postToIframe({
        type: 'GTA_COMMERCE_STATE',
        ready: Boolean(catalog.length && variant),
        options: catalog,
        selectedOptions: selected,
        price: variant ? variant.priceFormatted : '',
        compareAtPrice: compareAtPrice,
        adding: Boolean(pendingAdd),
        error: commerceError
      });
    }

    function stopCommerceSync() {
      if (!commerceSyncTimer) return;
      clearInterval(commerceSyncTimer);
      commerceSyncTimer = null;
    }

    function startCommerceSync() {
      stopCommerceSync();
      commerceSyncAttempts = 0;
      sendCommerceState();

      commerceSyncTimer = setInterval(function() {
        commerceSyncAttempts += 1;
        sendCommerceState();

        if (commerceSyncAttempts >= 20) stopCommerceSync();
      }, 500);
    }

    function setSelectedOption(name, value) {
      var normalizedName = String(name || '').trim().toLowerCase();
      var select = optionSelects.find(function(candidate) {
        var field = candidate.closest('.gta-app__field');
        var label = field ? field.querySelector('.gta-app__label') : null;
        return label && label.textContent.trim().toLowerCase() === normalizedName;
      });

      if (!select) return false;

      var hasValue = Array.prototype.some.call(select.options, function(option) {
        return option.value === String(value);
      });

      if (!hasValue) return false;

      select.value = String(value);
      commerceError = '';
      updateVariantDisplay();
      return true;
    }

    function setButtonLoading(isLoading) {
      if (!addButton) return;
      var variant = findSelectedVariant();
      addButton.disabled = isLoading || !variant || !variant.available;
      addButton.textContent = isLoading ? 'Preparing...' : addButton.dataset.defaultLabel;
      sendCommerceState();
    }

    function updateVariantDisplay() {
      var variant = findSelectedVariant();
      if (!variant) return;

      root.dataset.variantId = variant.id;
      if (priceNode) priceNode.textContent = variant.priceFormatted;

      if (comparePriceNode) {
        if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
          comparePriceNode.textContent = variant.compareAtPriceFormatted;
          comparePriceNode.hidden = false;
        } else {
          comparePriceNode.hidden = true;
        }
      }

      if (addButton) {
        addButton.disabled = Boolean(pendingAdd) || !variant.available;
      }

      sendCommerceState();
    }

    async function refreshCartDrawer(shouldOpen) {
      try {
        var response = await fetch('/?section_id=cart-drawer');
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('cart-drawer');
        var currentDrawer = document.querySelector('cart-drawer');

        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          currentDrawer.classList.remove('is-empty');
        }

        if (shouldOpen !== false && currentDrawer && typeof currentDrawer.open === 'function') {
          currentDrawer.open();
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        window.location.href = '/cart';
      }
    }

    function normalizeCartProperties(properties) {
      var cleaned = {};
      var changed = false;

      Object.keys(properties || {}).forEach(function(key) {
        var value = properties[key];
        var normalized = String(key || '').trim().toLowerCase();

        if (
          normalized === 'final render test'
          || normalized === 'final render'
          || normalized === 'final'
        ) {
          changed = true;
          return;
        }

        if (
          normalized === '_low quality design'
          || normalized === 'low quality design'
          || normalized === 'preview'
        ) {
          if (!cleaned._preview && value) {
            cleaned._preview = value;
          }

          changed = true;
          return;
        }

        cleaned[key] = value;
      });

      return {
        changed: changed,
        properties: cleaned
      };
    }

    async function sanitizeCartLineProperties() {
      var response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) return false;

      var cart = await response.json();
      var changed = false;

      for (var index = 0; index < (cart.items || []).length; index += 1) {
        var item = cart.items[index];
        var normalized = normalizeCartProperties(item.properties);

        if (!normalized.changed) continue;

        changed = true;

        var updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            properties: normalized.properties
          })
        });

        if (!updateResponse.ok) {
          throw new Error('Cart cleanup failed');
        }
      }

      return changed;
    }

    async function addDesignToCart(designId, variant, selection) {
      selection = selection || {};

      var previewUrl = supabaseBase + '/previews/' + designId + '.png';
      var finalUrl = selection.finalUrl || supabaseBase + '/final/' + designId + '.jpg';

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1,
            properties: {
              '_designId': designId,
              '_printSize': selection.printSize || '',
              '_frame': selection.frame || '',
              '_optionDetails': JSON.stringify(selection.optionDetails || []),
              '_orientation': selection.orientation || '',
              '_renderWidth': selection.renderWidth || '',
              '_renderHeight': selection.renderHeight || '',
              '_preview': previewUrl,
              '_final': finalUrl
            }
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Cart add failed');
      }

      await refreshCartDrawer();
    }

    function createDesignId() {
      return 'design_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
    }

    function sendCartResult(ok, message) {
      postToIframe({
        type: 'GTA_CART_RESULT',
        ok: ok,
        message: message || ''
      });
    }

    function clearPendingAdd() {
      if (pendingAdd && pendingAdd.timeout) {
        clearTimeout(pendingAdd.timeout);
      }

      pendingAdd = null;
      setButtonLoading(false);
    }

    function failCart(message) {
      commerceError = message;
      clearPendingAdd();
      sendCartResult(false, message);
      sendCommerceState();
    }

    function resetAll() {
      optionSelects.forEach(function(select, index) {
        select.value = initialOptions[index];
      });

      commerceError = '';
      clearPendingAdd();
      updateVariantDisplay();
      postToIframe({ type: 'RESET_DESIGN' });
      sendCommerceState();
    }

    function startCartFlow() {
      var variant = findSelectedVariant();

      if (pendingAdd) return;

      if (!variant) {
        failCart('Please choose a valid set of product options.');
        return;
      }

      if (!variant.available) {
        failCart('This option combination is currently unavailable.');
        return;
      }

      var selection = {
        options: selectedOptions(),
        optionDetails: selectedOptionDetails(),
        printSize: selectedOptionValue('Size'),
        frame: selectedOptionValue('Frame')
      };
      var designId = createDesignId();

      commerceError = '';
      pendingAdd = {
        designId: designId,
        variant: variant,
        selection: selection,
        timeout: setTimeout(function() {
          failCart('Saving your design is taking too long. Please try again.');
        }, 300000)
      };

      setButtonLoading(true);
      postToIframe({
        type: 'ADD_TO_CART',
        designId: designId,
        variantId: variant.id,
        options: selection.options,
        optionDetails: selection.optionDetails,
        printSize: selection.printSize,
        frame: selection.frame
      });
    }

    window.addEventListener('message', function(event) {
      if (event.source !== iframe.contentWindow || event.origin !== iframeOrigin || !event.data) return;

      if (event.data.type === 'GTA_IFRAME_READY' || event.data.type === 'GTA_COMMERCE_REQUEST') {
        sendCommerceState();
        sendAnalyticsState();
        return;
      }

      if (event.data.type === 'GTA_ANALYTICS_EVENT') {
        captureCustomizerAnalytics(event.data);
        return;
      }

      if (event.data.type === 'GTA_COMMERCE_CONNECTED') {
        stopCommerceSync();
        return;
      }

      if (event.data.type === 'GTA_OPTION_CHANGE') {
        if (!setSelectedOption(event.data.name, event.data.value)) {
          commerceError = 'That product option is not available.';
          sendCommerceState();
        }
        return;
      }

      if (event.data.type === 'GTA_ADD_TO_CART_REQUEST') {
        startCartFlow();
        return;
      }

      if (event.data.type === 'GTA_RESET_REQUEST') {
        resetAll();
        return;
      }

      if (event.data.type === 'GTA_PARENT_SCROLL') {
        if (window.matchMedia('(max-width: 900px)').matches) return;

        var requestedDelta = Number(event.data.deltaY);
        if (!Number.isFinite(requestedDelta) || requestedDelta === 0) return;

        var maxDelta = Math.max(window.innerHeight, 1);
        var scrollDelta = Math.max(-maxDelta, Math.min(maxDelta, requestedDelta));
        window.scrollBy({
          top: scrollDelta,
          left: 0,
          behavior: 'auto'
        });
        return;
      }

      if (event.data.type === 'IFRAME_HEIGHT') {
        var requestedHeight = Number(event.data.height);
        if (Number.isFinite(requestedHeight) && requestedHeight > 0 && requestedHeight < 10000) {
          iframe.style.height = Math.ceil(requestedHeight) + 'px';
        }
        return;
      }

      if (!pendingAdd || event.data.designId !== pendingAdd.designId) return;

      if (event.data.type === 'UPLOAD_COMPLETE') {
        clearTimeout(pendingAdd.timeout);
        pendingAdd.selection = pendingAdd.selection || {};
        var renderSize = event.data.renderSize || {};
        pendingAdd.selection.finalUrl = event.data.finalUrl || pendingAdd.selection.finalUrl || '';
        pendingAdd.selection.printSize = event.data.printSize || pendingAdd.selection.printSize || '';
        pendingAdd.selection.orientation = event.data.orientation || pendingAdd.selection.orientation || '';
        pendingAdd.selection.renderWidth = renderSize.width || pendingAdd.selection.renderWidth || '';
        pendingAdd.selection.renderHeight = renderSize.height || pendingAdd.selection.renderHeight || '';
        addDesignToCart(pendingAdd.designId, pendingAdd.variant, pendingAdd.selection)
          .then(function() {
            commerceError = '';
            sendCartResult(true);
          })
          .catch(function(error) {
            console.error('cart error:', error);
            commerceError = 'We could not add your design to the cart. Please try again.';
            sendCartResult(false, commerceError);
          })
          .finally(function() {
            clearPendingAdd();
          });
      }

      if (event.data.type === 'UPLOAD_ERROR') {
        console.error('design upload error:', event.data.message);
        failCart('We could not save your design. Please try again.');
      }
    });

    optionSelects.forEach(function(select) {
      select.addEventListener('change', updateVariantDisplay);
    });

    if (resetButton) {
      resetButton.addEventListener('click', resetAll);
    }

    if (addButton) {
      addButton.dataset.defaultLabel = addButton.textContent.trim();
      addButton.addEventListener('click', startCartFlow);
    }

    iframe.addEventListener('load', function() {
      sendViewportState();
      sendAnalyticsState();
      startCommerceSync();
    });
    window.addEventListener('resize', sendViewportState);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', sendViewportState);
    }

    sanitizeCartLineProperties()
      .then(function(changed) {
        if (changed) return refreshCartDrawer(false);
      })
      .catch(function(error) {
        console.warn('cart cleanup skipped:', error);
      });

    syncProductBarVisibility();
    initializeConsentTracking();
    updateVariantDisplay();
    sendViewportState();
    startCommerceSync();
  }

  document.querySelectorAll('[data-gta-app]').forEach(initGtaApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
